<template>
    <transition>
        <transition :name="routerTransition" mode="out-in">
            <router-view />
        </transition>
    </transition>
</template>
<script>
import useAppConfig from "@core/app-config/useAppConfig";

export default {
    methods: {},
    created() {},
    setup() {
        const { routerTransition } = useAppConfig();
        return {
            // App Config
            routerTransition
        };
    }
};
</script>

<style></style>
<style></style>
